//import AWS from "aws-sdk";
import React, { Component } from 'react';
// import Select from 'react-select';
import './App.css';
import Auth from '@aws-amplify/auth';
import Analytics from '@aws-amplify/analytics';
import { withAuthenticator } from 'aws-amplify-react'
import awsconfig from './aws-exports';
import Amplify, { API } from 'aws-amplify';
import awsmobile from './aws-exports';

// http://appventorywebhostingbucket.s3-website-us-east-1.amazonaws.com/

Amplify.configure(awsmobile);
// retrieve temporary AWS credentials and sign requests
Auth.configure(awsconfig);
// send analytics events to Amazon Pinpoint
Analytics.configure(awsconfig);

class App extends Component {

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value })
    // console.log (this.state)
  }
	
  handleChangeModeChange(event) {
  	// console.log(event.target.checked);
    // this.setState({ [event.target.name]: event.target.checked })
    localStorage.setItem( 'editMode', event.target.checked );
    window.location.reload();
    // console.log (this.state)
  }
	
  constructor(props) {
    super(props);
    this.handleSubmitTagPUT = this.handleSubmitTagPUT.bind(this);
    this.handleSubmitTagPOST = this.handleSubmitTagPOST.bind(this);
    this.handleSubmitTagsGET = this.handleSubmitTagsGET.bind(this);
    this.handleSubmitTagDELETE = this.handleSubmitTagDELETE.bind(this);

    this.handleSubmitVendorPOST = this.handleSubmitVendorPOST.bind(this);
    this.handleSubmitVendorDELETE = this.handleSubmitVendorDELETE.bind(this);

    this.handleSubmitInvItemPOST = this.handleSubmitInvItemPOST.bind(this);
    this.handleSubmitInvItemDELETE = this.handleSubmitInvItemDELETE.bind(this);

    this.vendorDropDown = this.vendorDropDown.bind(this);
    this.tagDropDown = this.tagDropDown.bind(this);

    this.handleChange = this.handleChange.bind(this)
    this.handleChangeModeChange = this.handleChangeModeChange.bind(this)
    this.state = { tags: null, vendors: null, invItems: null }
  }

  componentWillMount() {
  	this.fetchTags()
  	this.fetchVendors()
  	this.fetchInvItems()
  }

// ----------------------------- sendQueries
  sendQueryGET(stateName, path) {
  	let apiName = 'appvenwebapi';
	let myInit = { // OPTIONAL
	    headers: {}, // OPTIONAL
	    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
	    // queryStringParameters: {  // OPTIONAL
	    //     name: 'param'
	    // }
	}
	API.get(apiName, path, myInit).then(response => {
		if (stateName != null) {
			let val = response.data["body-json"]
			if (!val) {
		    	this.setState({[stateName]:[]}) // causes reload				
			}
			else {		
		    	this.setState({[stateName]:val}) // causes reload
		    }
		    // console.log(this.state) 
		}
		else {
			console.log(this.state)
		}
	}).catch(error => {
	    console.log(error.response) 
	});
  }

  sendQueryDELETE(path) {
  	let apiName = 'appvenwebapi';
	let myInit = { 
	    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
	}
	API.del(apiName, path, myInit).then(response => {
	    // console.log(response)
	    window.location.reload();
	}).catch(error => {
	    console.log(error.response) 
	});
  }

  sendQueryPOST(path, body) {
  	let apiName = 'appvenwebapi';
	let myInit = { // OPTIONAL
	    headers: {}, // OPTIONAL
	    body: body,
	    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
	}
	API.post(apiName, path, myInit).then(response => {
	    // Add your code here
	    // console.log(response.data["body-json"]);
	    window.location.reload();
	}).catch(error => {
	    console.log(error.response) 
	});
  }

  sendQueryPUT(path, body) {
  	let apiName = 'appvenwebapi';
	let myInit = { // OPTIONAL
	    headers: {}, // OPTIONAL
	    body: body,
	    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
	}
	API.put(apiName, path, myInit).then(response => {
	    // Add your code here
	    // console.log(response.data["body-json"]);
	    window.location.reload();
	}).catch(error => {
	    console.log(error.response) 
	});

  }

// ----------------------------- handles

// -------------------------- tag
  fetchTags() {
    let path = '/appven/tag/'; 
	this.sendQueryGET("tags", path);
  }

  handleSubmitTagsGET(event) {
    event.preventDefault();
    // console.log(this.state)
    let path = '/appven/tag' + this.state.tagID; 
	this.sendQueryGET(null, path);
  }

  handleSubmitTagPOST(event) {
    event.preventDefault();
	const name = this.state.tagName
	if (name == null) {
		alert("Please enter a name for your tag and try again.")
		return
	}
	let path = '/appven/tag'; 
    this.sendQueryPOST(path, {tagName:name})
  }

  handleSubmitTagPUT(event) {
    event.preventDefault();
	const name = this.state.tagName
	if (name == null) {
		alert("Please enter a name for your tag and try again.")
		return
	}
  	let id = event.target.value
  	// console.log(id)
	let path = '/appven/tag/' + id; 
	// console.log(path)
    this.sendQueryPUT(path, {tagName:name})
  }

  handleSubmitTagDELETE(event) {
  	let id = event.target.value
  	// console.log(id)
	let path = '/appven/tag/' + id; 
  	this.sendQueryDELETE(path)
  }

// -------------------------- vendor
  fetchVendors() {
    let path = '/appven/vendor/'; 
	this.sendQueryGET("vendors", path);
  }

  handleSubmitVendorPOST(event) {
    event.preventDefault();
	const name = this.state.vendorName
	if (name == null) {
		alert("Please enter a name for your vendor and try again.")
		return
	}
	const addr = this.state.vendorAddr || "--<>--"
	const contact = this.state.vendorContact || "--<>--"
	const email = this.state.vendorEmail || "--<>--"
	const notes = this.state.vendorNotes || "--<>--"
	const phone = this.state.vendorPhone || "--<>--"
	let path = '/appven/vendor'; 
    this.sendQueryPOST(path, {addr:addr,name:name,contact:contact,email:email,notes:notes,phone:phone})
  }

  handleSubmitVendorDELETE(event) {
  	let id = event.target.value
  	// console.log(id)
	let path = '/appven/vendor/' + id; 
  	this.sendQueryDELETE(path)
  }

// -------------------------- invitems
  fetchInvItems() {
    let path = '/appven/invitem/'; 
	this.sendQueryGET("invitems", path);
  }

  handleSubmitInvItemPOST(event) {
    event.preventDefault();
	const name = this.state.iiName
	if (name == null) {
		alert("Please enter a name for your item and try again.")
		return
	}
	const barcode = this.state.iiBarcode || "--<>--"
	const curCount = this.state.iiCurCount || 0
	const itemNumber = this.state.iiItemNum || "--<>--"
	const notes = this.state.iiNotes || "--<>--"
	const orderCriteria = this.state.iiOrderCriteria || 0
	const orderQuantity = this.state.iiOrderQuantity || 1
	const orderThreshold = this.state.iiOrderThreshold || 10
	const orderUnits = this.state.iiOrderUnits || "--<>--"
	const orderUpToQuantity = this.state.iiOrderUpToQuantity || 0
	const unitCost = this.state.iiUnitCost || 0

	const vendorId = this.state.iiVendor || "--<>--"
	const tags = this.state.iiTag || "--<>--"

	if(isNaN(curCount)){
		alert("Current Count needs to be a number. You have entered " + curCount);
		return
	}

	if(isNaN(orderQuantity)){
		alert("Order Quantity needs to be a number. You have entered " + orderQuantity);
		return
	}

	if(isNaN(orderUpToQuantity)){
		alert("Order up to Quantity needs to be a number. You have entered " + orderUpToQuantity);
		return
	}

	if(isNaN(orderThreshold)){
		alert("Order Threshold needs to be a number. You have entered " + orderThreshold);
		return
	}

	if(isNaN(unitCost)){
		alert("Unit Cost needs to be a number (e.g., 5 or 3.12). You have entered " + unitCost);
		return
	}

	let path = '/appven/invitem'; 
    this.sendQueryPOST(path, 
    	{name:name,barcode:barcode,curCount:curCount,itemNumber:itemNumber,notes:notes,
    		orderCriteria:orderCriteria,orderQuantity:orderQuantity,orderThreshold:orderThreshold,
    		orderUnits:orderUnits,orderUpToQuantity:orderUpToQuantity,unitCost:unitCost,vendorId:vendorId,tags:tags}
    )
  }

  handleSubmitInvItemDELETE(event) {
  	let id = event.target.value
  	// console.log(id)
	let path = '/appven/invitem/' + id; 
  	this.sendQueryDELETE(path)
  }

// ----------------------------- UI/data mix

// -------------------------- tag
  tagDropDown() {
  	const items = this.state.tags;
  	if (items === null || items.length === 0) { 
  		return ""
  	}
	return 	<select id='iiTag' onChange={this.handleChange} name='iiTag'><option>Pick a Tag from the list...</option>
		{items.map((op) => <option value={op.id} key={op.id}>{op.tagName}</option>)}
		</select>
  }

  tagList() {
  	const items = this.state.tags;
  	if (items === null || items.length === 0) { 
  		return <div><table ><tbody><tr key="notags">
  		<td>This is where you can remove items. No items to edit yet. Add items above.</td>
  		</tr></tbody></table></div> 
  	}

	return <div><h2>Edit</h2><table border='0'><tbody>{ items.map((op) => 
		<tr key={op.id}>
		<td>
		{op.tagName}
		</td>
		<td>
        <form>New Name:<input id="tagName" name="tagName" type="text" onChange={this.handleChange}/>
		<button value={op.id} type='button' key={op.id} onClick={this.handleSubmitTagPUT}>Save</button></form>
		</td>
		<td>
		<button value={op.id} type='button' key={op.id} onClick={this.handleSubmitTagDELETE}>Delete</button>
		</td></tr>
		) }</tbody></table></div>
  }

  tagAdd() {
  	return <div><h2>Add</h2><table border='0'><tbody><tr><td>      
  		<form>
        <label>Enter New Tag Name:</label>
        <input id="tagName" name="tagName" type="text" onChange={this.handleChange} />
        <button type='button' onClick={this.handleSubmitTagPOST}>Save New Tag</button>     
      	</form>
      	</td></tr></tbody></table></div>

  }

// -------------------------- vendor

  vendorDropDown() {
  	const items = this.state.vendors;
  	if (items === null || items.length === 0) { 
  		return ""
  	}
	return 	<select id='iiVendor' onChange={this.handleChange} name='iiVendor'><option>Pick a Vendor from the list...</option>
		{items.map((op) => <option value={op.id} key={op.id}>{op.name}</option>)}
		</select>
  }

  vendorAdd() {
  	return <div><h2>Add</h2><table border='0'><tbody><tr><td>
  	     <form>
        <label>Enter New Vendor:</label><br/>
        <input id="vendorName" placeholder="Name" name="vendorName" type="text" onChange={this.handleChange} /><br/>
        <input id="vendorAddr" placeholder="Address" name="vendorAddr" type="text" onChange={this.handleChange} /><br/>
        <input id="vendorContact" placeholder="Contact" name="vendorContact" type="text" onChange={this.handleChange} /><br/>
        <input id="vendorEmail" placeholder="Email" name="vendorEmail" type="text" onChange={this.handleChange} /><br/>
        <input id="vendorNotes" placeholder="Notes" name="vendorNotes" type="text" onChange={this.handleChange} /><br/>
        <input id="vendorPhone" placeholder="Phone" name="vendorPhone" type="text" onChange={this.handleChange} /><br/>
        <center><button type='button' onClick={this.handleSubmitVendorPOST}>Save New Vendor</button></center>
      	</form>
      	</td></tr></tbody></table></div>

  }

  vendorList() {
  	const items = this.state.vendors;
  	if (items === null || items.length === 0) { 
  		return <div><table ><tbody><tr key="novendors">
  		<td>This is where you can remove items. No items to edit yet. Add items above.</td>
  		</tr></tbody></table></div> 
  	}
  	var optionsList = items // JSON.parse(items.replace(/'/g, '"'));

	return <div><h2>Edit</h2><table border='0'><tbody>{ optionsList.map((op) => 
		<tr key={op.id}>
		<td>
		{op.name}
		</td>
		<td>
		<button value={op.id} type='button' key={op.id} onClick={this.handleSubmitVendorDELETE}>Delete</button>
		</td></tr>
		) }</tbody></table></div>
  }

// -------------------------- invitem

  invItemAdd() {
  	let tagDD = this.tagDropDown()
  	let vendorDD = this.vendorDropDown()

  	return <div><h2>Add</h2><table border='0'><tbody><tr><td>
  		<form>
        <label>Enter New Inventory Item:</label><br/>
        <input id="iiName" size='80' placeholder="Name" name="iiName" type="text" onChange={this.handleChange} /><br/>
        <input id="iiBarcode" size='80' placeholder="Barcode" name="iiBarcode" type="text" onChange={this.handleChange} /><br/>
        <input id="iiCurCount" size='80' placeholder="Current Count" name="iiCurCount" type="text" onChange={this.handleChange} /><br/>
        <input id="iiItemNum" size='80' placeholder="Item Number" name="iiItemNum" type="text" onChange={this.handleChange} /><br/>
        <input id="iiNotes" size='80' placeholder="Notes" name="iiNotes" type="text" onChange={this.handleChange} /><br/>
        <br/>

        <select id="iiOrderCriteria"  onChange={this.handleChange} name="iiOrderCriteria">
        <option value='0'>Order Set Quantity</option>
        <option value='1'>Up to Equal Quantity</option>
        </select><br/>
        
        <input id="iiOrderQuantity" size='80' placeholder="Order Quantity (how much to order for 'Order Set Quantity' above)" name="iiOrderQuantity" type="text" onChange={this.handleChange} /><br/>
        <input id="iiOrderUpToQuantity" size='80' placeholder="Order up to Quantity (order enough to match this total for 'Up to Equal Quantity' above)" name="iiOrderUpToQuantity" type="text" onChange={this.handleChange} /><br/>
        <input id="iiOrderThreshold" size='80' placeholder="Order Threshold (order when below this amount in inventory)" name="iiOrderThreshold" type="text" onChange={this.handleChange} /><br/>
        <br/>

        <input id="iiOrderUnits" size='80' placeholder="Order Units (e.g., jar, bottle, case)" name="iiOrderUnits" type="text" onChange={this.handleChange} /><br/>
        <input id="iiUnitCost" size='80' placeholder="Unit Cost (e.g., 5 = $5 per unit (e.g., case))" name="iiUnitCost" type="text" onChange={this.handleChange} /><br/>

        <br/>

        {tagDD}<br/>
		{vendorDD}<br/>

        <br/>
        <center><button type='button' onClick={this.handleSubmitInvItemPOST}>Save New Item</button></center>
      	</form>
      	</td></tr></tbody></table></div>

  }

  invItemList() {
  	const items = this.state.invitems;
  	if (items === null || items.length === 0) { 
  		return <div><table ><tbody><tr key="noinvitems">
  		<td>This is where you can remove items. No items to edit yet. Add items above.</td>
  		</tr></tbody></table></div> 
  	}
	return <div><h2>Edit</h2><table border='0'><tbody>{ items.map((op) => 
		<tr key={op.id}>
		<td>
		{op.name}
		</td>
		<td>
		Item Num: {op.itemNumber === "--<>--" ? "n/a" : op.itemNumber}
		</td>
		<td>
		<button value={op.id} type='button' key={op.id} onClick={this.handleSubmitInvItemDELETE}>Delete</button>
		</td></tr>
		) }</tbody></table></div>
  }


        //   <br/><br/><br/><br/>
        // <label>Enter Tag ID:</label>
        // <input id="tagID" name="tagID" type="text" onChange={this.handleChange} />
        // <button type='button' onClick={this.handleSubmitTagsGET}>Fetch Tag</button>


// ----------------------------- help

	overallHelpTop() {
		return <p>
		<a href="https://itunes.apple.com/us/app/keynote/id1449375865mt=8">The Appventory app (iOS)</a> : take inventory, create orders. 
		<br/>
		<br/>
		<u>Threshold</u>: The items to order are based on a <strong>threshold</strong>: When an item amount falls below the threshold, order more. 
		<br/>
		<br/>
		<u>Order Amount</u>: The amount to order is either a <strong>set 'order quantity'</strong> (e.g., order 5) <strong>or an 'up to equal amount'</strong> (e.g., order enough to equal 10 in stock).
		<br/>
		<br/>
		<u>Run Inventory</u>: You can <strong>view all inventory OR filtered by associated tags or vendors</strong> (e.g., just run inventory upstairs).
		<br/>
		<br/>
		<u>Create Order</u>: In the same way, you can <strong>create an order by a tag or for a given vendor/distributor.</strong>
		<br/>
		<br/>
		<strong>NOTE:</strong> For these reasons, it is recommended to create Vendors and Tags below first.
		<br/>
		<br/>
		<a href="https://www.brainwashinc.com/appventory">More info here</a>
		<br/>
		<br/>
		</p>
	}

	invHelpTop() {
		return <p>
		Add new items to your inventory below. 
		<br/>
		When you taken inventory with the app, any item that falls below the 'Order Threshold' (below) will be set to order.
		<br/>
		<br/>
		The amount to order will be determined by either 'Order Set Quantity' or 'Up to Equal Quantity.' If you select the 'Order Set Quantity', the amount in the 'Order Quantity' (e.g., 10) will be ordered.
		If you select 'Up to Equal Quantity', the 'Order up to Quantity' (e.g., order however many it takes to get to that value) amount will be ordered.
		<br/>
		<br/>
		<strong>Order Quantity</strong> - Used when 'Order Set Quantity' is selected. Whatever amount this is (e.g., 5) will be ordered when the current stock goes below the 'Order Threshold.'
		<br/>		
		<strong>Order up to Quantity</strong> - Used when 'Up to Equal Quantity' is selected. The order will include enough of this item to meet this value (e.g., if you have 5 and you set 'Order up to Quantity' to be 11, the app will set to order 6.)
		</p>
	}

	tagsHelpTop() {
		return <p>
		Once you have tags, you can assign tags to items. Tags can be things like 'Kitchen' or 'Freezer' or 'Spices' or 'Upstairs' - however you want to be able to take inventory.
		So if you only want to run inventory Upstairs or for frozen items, you can view your items based on the tag.
		<br/>
		<strong>NOTE:</strong> On this website, when you create new items, you can only select 1 tag. In the app, you can assign multiple tags to an item.
		<br/>
		</p>
	}

	vendorsHelpTop() {
		return <p>
		Creating Vendors helps in 2 ways (see below). Once you have Vendors defined, you can associate inventory items with them.
		<br/>
		1. Inventory Filter - You can view inventory, and therefore run inventory, for just one Vendor.
		<br/>
		2. Order Creation - You can create an order based on just specified Vendors.
		<br/>
		</p>
	}

// ----------------------------- render
  render() {
  	if (!this.state.tags || !this.state.vendors || !this.state.invitems) {
  		return 	(		<React.Fragment>
		<table><tbody><tr><td width="35"></td><td>
		<img alt="Appventory logo" src="http://brainwashinc.com/wp-content/uploads/2019/04/icon1024clear-768x768.png" width="200"/>
		</td></tr></tbody></table>
		<br/>
		<center>
		Loading...
		{this.state.tags ? "..." : ""}
		{this.state.vendors ? "..." : ""}
		{this.state.invitems ? "...." : ""}
		</center>
		</React.Fragment>
		)
  	}

  	let editMode = localStorage.getItem( 'editMode' ) === "true"
  	console.log(editMode)

  	let tagAdd = editMode ? "" : this.tagAdd() 
  	let tagActions = editMode ? this.tagList() : ""

  	let vendorAdd = editMode ? "" : this.vendorAdd()
  	let vendorActions = editMode ? this.vendorList() : ""

  	let invItemAdd = editMode ? "" : this.invItemAdd() 
  	let invItemsActions = editMode ? this.invItemList() : ""

  	// console.log(this.state.editMode)

   return (
		<React.Fragment>
		<table><tbody><tr><td width="35"></td><td> 
		<img alt="Appventory logo" src="http://brainwashinc.com/wp-content/uploads/2019/04/icon1024clear-768x768.png" width="200"/>
		<h1>Appventory Mangement</h1>

		<form>
 		  <h2>Edit Mode:<input type="checkbox" id="editMode" name="editMode" checked={editMode} onChange={this.handleChangeModeChange}/></h2>
		</form>

		<p><strong>Jump to:</strong>   <a href="#help">Quick Start</a>  |  <a href="#items">Inventory</a>   |  <a href="#tags">Tags</a>  |  <a href="#vendors">Vendors</a> </p> 
		<hr/>
		<a  className="nounderline" href="#inventory" id="items"><h1>Inventory</h1></a>
	
		{editMode ? "" : this.invHelpTop()}
		
			{invItemAdd}
			{invItemsActions}
			<br/>
			<hr/>

		<a className="nounderline" href="#tags" id="tags"><h1>Tags</h1></a>
		{editMode ? "" : this.tagsHelpTop()}

			{tagAdd}
			{tagActions}
			<br/>
			<hr/>

		<a className="nounderline" href="#vendors" id="vendors"><h1>Vendors</h1></a>
		{editMode ? "" : this.vendorsHelpTop()}

			{vendorAdd}
			{vendorActions}
			<br/>
		<hr/>		
		<a className="nounderline" href="#help" id="help"><h1>Quick Start</h1></a>
			{this.overallHelpTop()}
		</td></tr></tbody></table>

	     </React.Fragment> 
    );
  }

}

export default withAuthenticator(App, {
                // Render a sign out button once logged in
                includeGreetings: true, 
                // Show only certain components
                // authenticatorComponents: [MyComponents],
                // display federation/social provider buttons 
                // federated: {myFederatedConfig}, 
                // customize the UI/styling
                // theme: {myCustomTheme}
            });
